import React, {Component} from 'react';
import {Loading} from "../../components/Loading";

export default class PostsSection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            posts: [],
            loading: true
        };
        this.postsHandler = this.postsHandler.bind(this);
    }

    componentDidMount() {
        throw "Please override componentDidMount";
    }

    postsHandler(snapshot) {
        if (snapshot.exists()) {
            const posts = [];
            snapshot.forEach(function (childSnapshot) {
                const post = childSnapshot.val();
                posts.push(post);
            });
            this.setState({posts: posts.reverse()});
        }
    }

    componentDidUpdate() {
        const {loading, posts} = this.state;
        if (loading && posts.length > 0) {
            this.setState({loading:false});
        }
    }

    render() {
        return (
            <Loading visible={this.state.loading}/>
        );
    }

}


// WEBPACK FOOTER //
// ./src/visitors/subscribers/PostsSection.js